module.exports = __webpack_public_path__ + "static/media/001-balloon-white.8f4c8899.svg";